/**
 * The "Response Page" links a reservation card offers: one per requested
 * restaurant whose confirm code the viewer holds (RM-319). The codes line up
 * with requestedRestaurantsArray by index. RM holds every code; a restaurant
 * team gets only its own restaurants' codes and null for the others, so a
 * restaurant without a code gets no link — never a link to nothing.
 */
export function responsePageLinks(reservation, { isAdmin = false, myRestaurants = [] } = {}) {
  const names = reservation?.requestedRestaurantsArray || []
  const codes = reservation?.confirmationUuids || []

  return names
    .map((name, index) => ({ name, index, code: codes[index] }))
    .filter(({ name, code }) => !!code && (isAdmin || myRestaurants.includes(name)))
}
